/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LocationIcon from 'Components/common/assets/svgIcons/LocationIcon';
import SmallButton from '../../common/components/SmallButton';
import {
  Progress, Tooltip, Modal, Button,
} from 'antd';
// import DiscIconSmall from 'Components/common/assets/svgIcons/DiscIconSmall';
// import DiscBackgroundImage from 'Components/common/assets/svgIcons/DiscBackgroundImage';
// import DiscBackgroundImage from 'Components/common/assets/images/discImageBackground.svg';
import CompanyWidgetSmall from 'Components/common/components/CompanyWidgetSmall';
import { CompanyPersonality } from 'Types/CompaniesTypes';
import {
  ArcheType, PersonalityTypes, PersonCard, SocialLink, SocialLinks,
} from 'Types/PersonTypes';
import {
  backgroundColorParsing,
  isGuest,
  IsMobile,
  IsTablet,
  valueToObject,
  getCurrentTime,
  isGuestfromEmail,
} from 'Utils/UtilityFunctions';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectActivetype, selectData, selectHighlight } from 'Selector/CertificationSelector';
import classNames from 'classnames';
import PersonPhoneIcon from 'Components/common/assets/svgIcons/PersonPhoneIcon';
import PersonEmailIcon from 'Components/common/assets/svgIcons/PersonEmailIcon';
import CopyMailIcon from 'Components/common/assets/svgIcons/CopyMailIcon';
import { actions as helperActions } from 'Slice/HelperSlice';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { COMPANY_OVERVIEW_ROUTE, DISCLAIMER_MESSAGE_PERSON_PAGE, OUTLOOK_CALENDAR_URL } from 'Utils/Constants';
import { selectIsRecommended } from 'Selector/PersonProfileSelector';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import { isExpandFlag } from 'Selector/UISelector';
import DragWrapper from 'Components/people/components/DragWrapper';
import MsalAuthComponent from 'Components/MicrosoftEventScheduling';
import PersonMeetingIcon from 'Components/common/assets/svgIcons/PersonMeetingIcon';
import TwitterIcon from '../../common/assets/svgIcons/TwitterIcon';
import LinkedInIcon from '../../common/assets/svgIcons/LinkedInIcon';
import {
  primaryHeadingColor, wMedium,
  secondaryFont, primaryFont, wMBold,
  discPlaceholder, maxWidth, retina, maxTablet, maxMobile, SecondaryColor, wLight,
  minWidthApp,
  wMLight,
} from '../../../Utils/utilsStyle';
import PeopleWidget from '../../common/components/PeopleWidget';




type Props = {
  personType?: string,
  personInfo?: PersonCard;
  socialLinks?: SocialLinks;
  archeType?: ArcheType;
  personName?: string,
  isPersonMainCard?: boolean,
  personImage?: string,
  companyName?: string,
  companyLogo?: string,
  personDesignation?: string,
  companyId?: number,
  location?: string,
  personAdded?: boolean,
  confidence?: string
  personFollowLoading?: boolean,
  hideFollow?: boolean,
  companyPersonality: CompanyPersonality[];
  personalityTypes?: PersonalityTypes[]
  onClickHandler?: () => void,
  isSriPage?: boolean
  customClassName?: string
  disclessFlag?: boolean
  isDrag?: (d: boolean) => void
} & typeof defaultProps;

const defaultProps = {
  archeType: {
    color: '#ff0000',
    image: `${discPlaceholder}`,
    name: '',
    personality: '',
  },
  personType: '',
  isPersonMainCard: false,
  socialLinks: { data: [] } as SocialLinks,
  companyId: 0,
  personName: '',
  personDesignation: '',
  personImage: '',
  companyName: '',
  companyLogo: '',
  location: '',
  personAdded: true,
  confidence: '',
  personFollowLoading: false,
  hideFollow: false,
  personalityTypes: [{
    color: '',
    description: '',
    image: '',
    key: '',
    value: '',
  }],
  personInfo: {},
  onClickHandler: () => { },
  isDrag: (d: boolean) => { console.log(d); },
  isSriPage: false,
  customClassName: '',
  disclessFlag: false,
};

const Wrapper = styled.div`
&.person-page-header {
  &::after {
    width: 0px;
  }
  min-height: 230px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    min-height: 178px;
    padding: 12px 12px 8px;
  }
  .transition-visible {
    visibility: visible;
    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
  }
  .transition-hidden {
    visibility: hidden;
    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
  }
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
    margin-bottom: 12px;
    padding: 16px;
  .progress-social-div {
    position: relative;
    top: unset;
    right: unset;
    width: 100%;
    @media all and (max-width: ${maxWidth}), ${retina} {
      position: absolute;
      top: 12px;
      right: 18px;
      width: calc(100% - 30px);
    }
    .social-icons-wrap {
      .scc-place {
        height: 16px;
        width: 16px;
        svg {
          height: 16px;
          width: 16px;
        }
      }
    }
    .progress-social {
      display: none;
    }
  }
  .person-image-container {
    padding-top: 0px;
    margin-top: 14px;
    .image-container {
      width: 110px;
      height: 110px;
      min-width: 110px;
      margin: -20px;  
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 72px;
        height: 72px;
        min-width: 72px;
      }
      svg {
        display: none;
      }
      .person-item-widget {
        width: 82%;
        height: 82%;
        min-width: 82%;
      }
    }
  }
  .person-name {
    color: #0D0D0D;
    font-size: 16px;
    line-height: 22px;
    margin: 12px 0px 12px;
    padding: 0 5px;
  }
  .designation-person  {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 0px;
  }
  .company-container {
    margin-top: 0px;
    margin-bottom: 7px;
    &.disable{
      pointer-events: none;
    }
    .company-logo-container {
      width: 21px;
      height: 21px;
      border-radius: 0px;
    }
    .designation-container {
      .designation  {
        color: #67696A;
        font-size: 14px;
        font-weight: ${wLight};
      }
    }
  }
  .location-wrapper, .recommendation, .person-contact-div {
    display: none;
  }
  .small-button-chinese {
    height: 34px;
    padding: 6px 22px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: 30px;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .drawer-btn-action {
    .ant-badge {
      .btn-notes-drawer {
        height: 34px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 30px;
          font-size: 14px;
        }
      }
    }
  }
}
 position: relative;
 padding: 0 25px;
 @media all and (max-width: ${maxTablet}) {
   padding: 0 15px;
 }
 @media all and (max-width: ${maxMobile}) {
  &:after{
    display: none;
  }
 }
 &:after{
    content:"";
    width:1px;
    height: 92%;
    position: absolute;
    right: 0px;
    top: 0px;
    background-color:#F5F1EA;
  }
  .progress-social-div{
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 43px);
    position: absolute;
    top: 16px;
    right: 10px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      top: 12px;
    }
    .progress-social {
      position: relative;
      display: flex;
      align-items: center;
      z-index: 1; // look for side effects
      ::before {
        content: "%";
        position: absolute;
        top: 6px;
        font-family: 'Roboto';
        font-size: 9px;
        font-weight: 700;
        z-index: 1;
        right: 34px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          right: 32px;
        }
      }
      .ant-progress-inner {
        width: 35px !important;
        height: 35px !important;
        .ant-progress-text {
          margin-left: -2px;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 30px !important;
          height: 30px !important;
          .ant-progress-text {
            margin-left: -1px;
          }
        }
      }
      div > div > span {
        font-family: ${secondaryFont};
        font-weight: ${wMedium};
        font-size: 15px;
        letter-spacing: -0.63px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 12px;
        }
      }
    }
    .social-icons-wrap {
      display: flex;
      flex-direction: row-reverse;
      z-index: 1;
      .scc-place {
        margin-right: 0px;
        svg {
          width: 30px;
          height: 30px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            width: 20px;
            height: 20px;
          }
        }
        &.twit-icon {
          margin-right: 8px;
        }
      }
    }
  }
.person-image-container {
  position: relative;
  padding-top: 25px;
  @media all and (max-width: ${minWidthApp}) {
    padding-top: 40px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding-top: 0px;
  }
  .progress {
    &::before {
      right: 32px;
    }
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: -14px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      left: 10px;
    }
    @media all and (max-width: 1280px){
      left: -20px;
    }
    @media all and (max-width: ${maxMobile}) {
      left: -55px;
    }
    .ant-progress-inner {
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 30px !important;
        height: 30px !important;
        .ant-progress-text {
          margin-left: -1px;
        }
      }
    }
    div > div > span {
      font-family: ${secondaryFont};
      font-weight: ${wMedium};
      font-size: 15px;
      letter-spacing: -0.63px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 12px;
      }
    }
  }
  .person-image {
    margin: 3px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      min-width: auto;
    }
    @media all and (min-width: 1500px) {
      min-width: auto;
    }
  }
  .image-container {
    height: 300px;
    width: 300px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 180px;
      height: 180px;
    }

    @media all and (min-width: 1500px) {
      width: 180px;
      height: 180px;
      min-width: 180px;
      margin: 20px 0px 0px;
    }
    .person-item-widget {
      &.person-profile-widget {
        .name-wrapper {
          h4 {
            font-size: 14px !important;
            padding-left: 0px;
          }
          .anticon  {
            display: none;
          }
        }
      }
    }
    .holo-svg {
      height: 92%;
      width: 100%;
      min-width: 100%;
    }
  }
}

  .person-name{
    color: ${primaryHeadingColor};
    font-weight:${wMLight};
    font-family: ${secondaryFont};
    font-size: 28px;
    text-align: center;
    margin: 10px 0px 12px;
    letter-spacing: -0.85px;
    line-height: 34px;
    padding: 0px 20px;
    text-transform: capitalize;
    word-break: break-all;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 24px;
      line-height: 26px;
    }
  }
   .designation-person {
      color: #424B50;
      line-height: 18px;
      font-size: 16px;
      font-weight: ${wMLight};
      font-family: ${primaryFont};
      text-align: center;
      margin-bottom: 8px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 14px;
        line-height: 15px;
      }
    }
    .location-wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      svg {
        min-width: 13px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-top: -1px;
          width: 10px;
          min-width: 10px;
        }
      }
      .location-person {
        color: #424B50;
        line-height: 20px;
        font-size: 14px;
        font-weight: ${wMedium};
        font-family: ${primaryFont};
        text-align: center;
        margin-bottom: 0px;
        position: relative;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
    .person-contact-div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      .auth-button {
        padding: 0px;
      }
      .icon-div {
        z-index: 1;
        &:hover, &:focus-visible{
          background-color: ${SecondaryColor} !important;
          .person-phone-icon {
            path {
              fill: #fff;
              stroke: #fff;
            }
          }
          .person-email-icon {
            path {
              fill: #fff;
            }
          }
          .person-meeting-icon {
            path {
              fill: #FFF;
            }
          }
        }
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color:  #F7F7F7;
        border: 2px solid #DDD;
        border-radius: 50%;
        width: 34px;
        height: 34px;
        cursor: pointer;
        &:first-child {
          margin-right: 7px;
        }
        &:last-child {
          margin-left: 7px;
        }
        &:only-child {
          margin: 0px;
        }
      }
    }
  .company-container {
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;

    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-bottom: 15px;
    }

    &.company-pointing{
      cursor: pointer
    }

    .company-logo-container {
      width: 90px;
      height: 50px;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 40px;
        width: 70px;
      }
      .company-logo {
        height: 90%;
        width: 94%;
        border-radius: 8.2px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          border-radius: 5.2px;
        }
      }
    }
   
    .designation-container {
      width: auto;
      padding: 0px 0px 0px 10px;
      max-width: 190px;
      .designation {
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        font-size: 16px;
        line-height: 18px;
        letter-spacing: -0.38px;
        color: #424B50;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
  .item-label{
    color:${primaryHeadingColor};
    font-size: 18px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    text-align: right;
    width:80px;
    display: inline-block;
    margin-left:44px;
  }
  .recommendation {
    margin: 12px 0px;
  }
  .global-tooltip-element {
    .section-detail-tip {
      width: 20px;
      height: 20px;
      .ant-tooltip {
        .ant-tooltip-content {
          .ant-tooltip-inner {
            .tooltip_wrapper {
              padding: 10px 10px 0px 0px;
              .tooltip-text-tour {
                white-space: unset;
                display: block;
                .disclaimer-text {
                  color: #5E7079;
                  font-family: ${primaryFont};
                  font-weight: ${wLight};
                  line-height: 14px;
                  font-size: 12px;
                  @media all and (max-width: ${maxWidth}) , ${retina} {
                    font-size: 10px;
                  }
                  .starting-span {
                    display: block;
                    .primary-color {
                      display: inline-block;
                      font-weight: ${wMBold};
                      font-size: 14px;
                      @media all and (max-width: ${maxWidth}) , ${retina} {
                        font-size: 12px;
                      }
                    }
                    .one-liner-text {
                      display: block;
                      margin: 10px 0;
                      @media all and (max-width: ${maxWidth}) , ${retina} {
                        margin: 5px 0;
                      }
                    }
                  }
                  .alphabetical-list-text {
                    display: block;
                    padding-left: 14px;
                    @media all and (max-width: ${maxWidth}) , ${retina} {
                      padding-left: 12px;
                    }
                    li {
                      ::marker {
                        font-weight: ${wMBold};
                      }
                      &:first-child {
                        margin-bottom: 10px;
                        @media all and (max-width: ${maxWidth}) , ${retina} {
                          margin-bottom: 5px;
                        }
                      }
                    }
                    li {
                      .numeric-list-text {
                        margin-top: 5px;
                        padding-left: 12px;
                        display: block;
                        @media all and (max-width: ${maxWidth}) , ${retina} {
                          padding-left: 9px;
                        }
                        li {
                          margin-bottom: 5px;
                          @media all and (max-width: ${maxWidth}) , ${retina} {
                            margin-bottom: 3px; 
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

// const Disc = styled.div`
//   .disc-img {
//     position: absolute;
//     bottom: 2px;
//     right: 0px;
//     display: none;
//     @media all and (max-width: 1800px){
//       bottom: 8px;
//       right: 0px;
//     }
//     @media all and (max-width: 1500px){
//       bottom: 10px;
//       right: 15px;
//     }
//     @media all and (max-width: 1440px){
//       bottom: 8px;
//       right: 10px;
//       img {
//         width: 25px;
//         height: 25px;
//       }
//     }
//     @media all and (max-width: 1280px){
//       bottom: 8px;
//       right: 0px;
//       img {
//         width: 25px;
//         height: 25px;
//       }
//     }
//     img {
//       @media all and (max-width: ${maxWidth}) , ${retina} {
//         .ant-progress-text {
//           margin-left: -1px;
//         }
//       }
//     }
//   }
// `;

const percentDefault = {
  percent: 0,
};

const PercentSup: React.FC<{ percent?: number }> = function PercentSup({ percent }) {
  return (
    <>
      {percent}
      <sup>%</sup>
    </>
  );
};

PercentSup.defaultProps = percentDefault;

const PersonInfo = function PersonInfo(props: Props) {
  const {
    personType,
    archeType,
    personName,
    personImage,
    companyName,
    companyLogo,
    personDesignation,
    companyPersonality,
    location,
    socialLinks,
    companyId,
    personAdded,
    confidence,
    personFollowLoading,
    personalityTypes,
    onClickHandler,
    hideFollow,
    isPersonMainCard,
    personInfo,
    isSriPage,
    customClassName,
    disclessFlag,
    isDrag,
  } = props;
  const navigate = useNavigate();
  const isGuestUser = isGuest() || isGuestfromEmail();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { name, color } = archeType;
  const companyWidgetClick = () => {
    if (!isGuestUser && companyName !== 'Not Employed') { if (companyId && companyId > 0) navigate(`${COMPANY_OVERVIEW_ROUTE}${companyId}`); }
  };
  console.log(isPersonMainCard);

  const data = useSelector(selectData);
  const dispatch = useDispatch();
  const isMob = IsMobile();
  const isTab = IsTablet();
  const isRecommended = useSelector(selectIsRecommended);
  const host = window.location.href;
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isExpand = useSelector(isExpandFlag);
  const startTime = getCurrentTime();

  const handleClick = () => {
    onClickHandler();
    if (!personAdded) {
      dispatch(certificationActions.certificationAction({
        type: 'person_follow',
        source: 'search',
        data,
      }));
    }
    if (isRecommended) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('peopleDashboard_recommended_follow_person', 0, {
          person_id: personInfo.personId,
          host,
        }),
      ));
    }
  };

  const copyHandle = async (text: string) => {
    await navigator.clipboard.writeText(text);
    dispatch(helperActions.setNotification({
      message: 'Text Copied!',
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
  };

  const tooltipContent = (title: string, emailFlag?: boolean) => (
    <span
      className="tooltip-content-div"
      onClick={(e) => e.preventDefault()}
      onKeyPress={(e) => e.preventDefault()}
      tabIndex={0}
      role="button"
    >
      {emailFlag ? <span className="title"> Email Address:</span> : <span className="title"> Phone Number:</span>}
      <span className="weight-700">{title}</span>
      <CopyMailIcon onClick={() => copyHandle(title)} />
    </span>
  );
  useEffect(() => {
    const property: HTMLImageElement | null = document.getElementsByClassName('person-page-header')[0] as HTMLImageElement | null;

    if (property) {
      if (isExpand) {
        property.classList.remove('transition-visible');
        property.classList.add('transition-hidden');
      } else {
        setTimeout(() => {
          property.classList.remove('transition-hidden');
          property.classList.add('transition-visible');
        }, 500);
      }
    }
  }, [isExpand]);

  const handleAuthButtonClick = () => {
    // setIsModalVisible(true);
    let calendarUrl = OUTLOOK_CALENDAR_URL;

    if (personInfo?.email) {
      const encodedEmail = encodeURIComponent(personInfo.email);
      calendarUrl += `?to=${encodedEmail}`;
    }
    window.open(calendarUrl, '_blank');
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleLinkedInClick = () => {
    dispatch(helperActions.callFlurryEvent(
      valueToObject('linkedin_personprofile', startTime, {
        person_id: personInfo?.personId,
        person_type: personType,
        host
      }),
    ));
  };

  return (
    <Wrapper className={classNames(`${customClassName}`)}>
      <Modal
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        centered
        width={379}
        wrapClassName="schedule-meeting-modal"
      >
        <MsalAuthComponent
          handleModalClose={handleModalClose}
          profileInfoEmail={personInfo?.email}
        />
      </Modal>
      {!isMob ? (
        <div className="progress-social-div">
          {!disclessFlag ? (
            <div className={classNames('social-icons-wrap')}>
              {socialLinks?.data?.map((item: SocialLink) => {
                if (item.link && item.type === 'twitter') {
                  return (
                    <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place twit-icon" rel="noreferrer" aria-label="button">
                      <TwitterIcon />
                    </a>
                  );
                }
                if (item.link && item.type === 'linkedin') {
                  return (
                    <a
                      key={item.link}
                      href={item.link}
                      target="_blank"
                      className="social-icon scc-place"
                      rel="noreferrer"
                      aria-label="button"
                      onClick={handleLinkedInClick}
                    >
                      <LinkedInIcon />
                    </a>
                  );
                }
                return null;
              })}
            </div>
          ) : null}
          {/* <div className={classNames('social-icons-wrap')}>
            {socialLinks?.data?.map((item: SocialLink) => {
              if (item.link && item.type === 'twitter') {
                return (
                  <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place twit-icon" rel="noreferrer" aria-label="button">
                    <TwitterIcon />
                  </a>
                );
              }
              if (item.link && item.type === 'linkedin') {
                return (
                  <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place" rel="noreferrer" aria-label="button">
                    <LinkedInIcon />
                  </a>
                );
              }
              return null;
            })}
          </div> */}
          <div className="progress-social">
            <Progress
              type="circle"
              percent={Number(confidence)}
              width={40}
              strokeColor="#1EC252"
              strokeWidth={8}
              format={(percent) => percent}
            />
            <HeadingWithToolTip
              heightIcon="19px"
              widthIcon="16px"
              heightIconSm="20px"
              widthIconSm="13px"
              customWidth="292px"
              toolTipText={DISCLAIMER_MESSAGE_PERSON_PAGE}
              toolPlacement="bottomLeft"
              midTabletFlag
              htmlFlag
            />
          </div>
        </div>
      ) : null}
      <div className="d-flex justify-content-center person-image-container">
        <div className="image-container">
          {isMob ? (
            <div className="progress">
              <Progress
                type="circle"
                percent={Number(confidence)}
                width={40}
                strokeColor="#1EC252"
                strokeWidth={8}
                format={(percent) => percent}
              />
              <HeadingWithToolTip
                heightIcon="19px"
                widthIcon="16px"
                heightIconSm="20px"
                widthIconSm="13px"
                customWidth="280px"
                toolTipText={DISCLAIMER_MESSAGE_PERSON_PAGE}
                toolPlacement="bottomLeft"
                midTabletFlag
                htmlFlag
              />
            </div>
          ) : null}

          <DragWrapper key={personInfo?.personId} isDrag={isDrag}>
            <PeopleWidget
              diameter="100%"
              diameterSm="100%"
              diameterXsm="170px"
              personInfo={personInfo}
              persona={color}
              logo={personImage}
              personality={name}
              executiveType={personType}
              hidePersonality={!(personalityTypes.length > 0)}
              imageClassName="person-image"
              ringPadding="0px"
              ringPaddingSm="0px"
              wrapperColor={backgroundColorParsing(personalityTypes || [])}
              personName={personInfo.personName}
              personaType={personInfo?.archeType?.name}
              personId={personInfo.personId}
              personalityTypesColors={personInfo?.personalityTypes}
              isPersonStyle
              disclessFlag={disclessFlag}
            />
          </DragWrapper>


        </div>
      </div>
      <h1 className={`person-name ${customClassName !== '' ? 'text-truncate-one-line' : ''}`}>{personName}</h1>
      <p className={`designation-person ${customClassName !== '' ? 'text-truncate-one-line' : 'text-truncate-three-line'}`}>
        {personDesignation}
      </p>
      {companyLogo && companyName && (
        <span
          className={`company-container ${companyId && companyId > 0 && companyName !== 'Not Employed' && !isGuestUser ? 'company-pointing' : ''} `}
          onClick={() => companyWidgetClick()}
          onKeyPress={() => companyWidgetClick()}
          role="button"
          tabIndex={0}
          aria-label="View company profile"
        >
          <CompanyWidgetSmall
            logo={companyLogo}
            wrapperClassName="company-logo-container person-page-personality-fix"
            imgClassName="company-logo"
            triggerColor={[]}
            persona={companyPersonality}
            checkBox={false}
            backgroundSize="contain"
          />
          <div className="designation-container">
            <Tooltip
              arrow={false}
              trigger="hover"
              placement="top"
              getPopupContainer={(e: HTMLElement) => e}
              className="triggers-bullet-tooltip person-designation-tip"
              color="#fff"
              title={companyName}
            >
              <div className="designation text-truncate-two-line">{companyName}</div>
            </Tooltip>
          </div>
        </span>
      )}
      <div />
      {
        location
          ? (
            <div className="location-wrapper">

              <LocationIcon />

              <p className="location-person ml-1 text-truncate">{location}</p>
            </div>
          ) : null
      }
      <p className="recommendation" />
      {!isGuestUser ? (
        <div className="person-contact-div">
          {personInfo.phone ? (
            !isTab ? (
              <Tooltip
                placement="top"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip tooltip-with-copy-action"
                color="#fff"
                title={tooltipContent(personInfo.phone)}
                arrow={false}
              >
                <a href={`tel:${personInfo.phone}`} className="icon-div">
                  <PersonPhoneIcon />
                </a>
              </Tooltip>
            ) : (
              <a href={`tel:${personInfo.phone}`} className="icon-div">
                <PersonPhoneIcon />
              </a>
            )
          ) : null}
          {personInfo.email ? (
            !isTab ? (
              <Tooltip
                placement="top"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip tooltip-with-copy-action"
                color="#fff"
                title={tooltipContent(personInfo.email, true)}
                arrow={false}
              >
                <a href={`mailto:${personInfo.email}`} className="icon-div">
                  <PersonEmailIcon />
                </a>
              </Tooltip>
            ) : (
              <a href={`mailto:${personInfo.email}`} className="icon-div">
                <PersonEmailIcon />
              </a>
            )
          ) : null}
          {!isSriPage
            ? (
              <Tooltip
                placement="topLeft"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip person-designation-tip"
                color="#fff"
                title="Schedule Meeting"
                arrow={false}
              >
                <Button onClick={handleAuthButtonClick} className="auth-button icon-div">
                  <PersonMeetingIcon />
                </Button>
              </Tooltip>
            ) : null}

        </div>) : null}
      <div className="d-flex justify-content-center">
        {!hideFollow
          && (

            <SmallButton
              title={personAdded ? 'Unfollow' : 'Follow'}
              variant={personAdded ? 'outlined' : 'filled'}
              color="#001760"
              loading={personFollowLoading}
              onButtonClick={handleClick}
            />

          )}
        {isSriPage || hideFollow ? null : (
          <div className={classNames({ highlightedComponent: isHighlight && currentType === 'person_note_write' })}>
            <DrawerPeopleMoveReason
              isPeopleNotes
              personId={personInfo.personId}
            />
          </div>
        )}
      </div>
    </Wrapper>
  );
};
PersonInfo.defaultProps = defaultProps;
export default PersonInfo;